(function() {
    'use strict';

    angular.module('file', [
            'ui.router',

            'file.constants',
            'file.services'
        ])
        .config(uiRouting);

    uiRouting.$inject = ['$stateProvider', 'userPermissionsConst', 'filePermissionsConst'];

    function uiRouting($stateProvider, userPermissionsConst, filePermissionsConst) {
        $stateProvider
            .state('layout.file', {
                abstract: true,
                url: '/file',
                data: {
                    title: 'Pliki',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.file.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/file/views/file-list/file-list.html',
                        controller: 'FileListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: filePermissionsConst.view
                }
            })
            .state('layout.file.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/file/views/file-create/file-create.html',
                        controller: 'FileCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: filePermissionsConst.add
                }
            })
            .state('layout.file.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/file/views/file-update/file-update.html',
                        controller: 'FileUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: filePermissionsConst.update
                }
            });
    }
})();
